import { mutations } from "./mutations";
import { actions } from "./actions";

const state = {
  isHome: false,
  isAccount: false,
  isTransfer: false,
  isFund: false,
  isUtility: false,
  isLoan: false,
  isInvestment: false,
  isMisc1: false,
  isMisc2:false,
  isMisc3: false,
  isMisc4: false,
  isMisc5: false,
  isMisc6: false,
  isMisc7: false,
  isMisc8: false,
  isMisc9: false,
  isMisc10: false
};

export default { state, mutations, actions };
